module.exports = __webpack_public_path__ + "assets/media/day28.1517c36b.mp3";